<template>
    <header class="account-header">
        <account-info-box />
    </header>
</template>

<script>
import AccountInfoBox from '../AccountInfoBox/AccountInfoBox.vue';
export default {
    components: { AccountInfoBox },
};
</script>

<style lang="scss">
@import 'style';
</style>
